export default "__VITE_ASSET__CrD6XzTc__"